import { useTranslation } from 'react-i18next'

import { FlexBox } from 'components/Box'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { TrafficShareHeaderColumnCell } from './components/TrafficShareHeaderColumnCell'
import { HeaderColumnCellProps } from './types'

export const HeaderColumnCell = ({
  basePrefix,
  header,
}: HeaderColumnCellProps): React.JSX.Element => {
  const { t } = useTranslation('features/abTests', { keyPrefix: 'common' })

  switch (basePrefix) {
    case 'reportedKeyValue':
      return (
        <FlexBox axis='x'>
          {header}
          <Tooltip content={t('variants.table.reportedKeyValue.tooltip')} />
        </FlexBox>
      )
    case 'trafficShare':
      return <TrafficShareHeaderColumnCell header={header} />
    default:
      return <>{header}</>
  }
}
